import {forwardRef, useState} from "react";
import {t} from "i18next";
import {getImagePath, getImagePathWithTheme, imgPathPerfix, isDarkMode} from "../../utils";
import {Tooltip} from "antd";
import {
    DEFAULT_IMPORT_MODE,
    EVENT_FILE_MODE_SMALL_TIP_VISIBLE,
    KEY_DRAW_FRAME_HEIGHT, KEY_FILE_IMPORT_MODE
} from "@/Const";


const FileImportMode = forwardRef((props:{onCallback:any}, ref)=>{

    const [arrayMode,setArrayMode] = useState(DEFAULT_IMPORT_MODE());
    const [isShowTips,setIsShowTips] = useState(localStorage.getItem(EVENT_FILE_MODE_SMALL_TIP_VISIBLE) == 'true' || localStorage.getItem(EVENT_FILE_MODE_SMALL_TIP_VISIBLE) == undefined)

    return(
        <div className={'default-font-size'} style={{width:'332px',padding:'8px 6px',marginBottom:'0px'}}>
            <div className={'flex-row-vertical-center'} style={{justifyContent:'space-between'}}>
                {
                    arrayMode.map(p=>{
                        return <div className={'flex-column-center cursor-pointer'}
                                    style={{background:p.isHover?'var(--file-import-mode-background-hover-color)':'var(--file-import-mode-background-color)',width:'150px',height:'116px',borderRadius:'8px',border:p.isHover?`1px solid ${isDarkMode()?'var(--border-color)':'#3670F7'}`:`1px solid var(--border-color)`}} onMouseEnter={()=>{
                            var arrayNew = [...DEFAULT_IMPORT_MODE()];
                            const item = arrayNew.find(m=>m.id == p.id);
                            if (item){
                                item.isHover = true;
                            }
                            setArrayMode(arrayNew);

                        }} onMouseLeave={()=>{
                            var arrayNew = [...DEFAULT_IMPORT_MODE()];
                            setArrayMode(arrayNew);
                        }} onClick={()=>{
                            props.onCallback(p.id);
                        }}>
                            <img style={{width: '44px', height: '44px'}} src={getImagePathWithTheme(p.img+(p.isHover?'_hover':''))}/>
                            <div className={'flex-row-vertical-center'}>
                                <span className={'font-family-semi-bold font-size-13'} style={{color:p.isHover?'#3670F7':(isDarkMode()?'#FBFBFB':'#393834')}}>{p.title}</span>
                                <Tooltip arrow={false} title={p.tips} placement={"bottom"}>
                                    <img className={'img-14 ml-2'} src={getImagePath('file_mode_help')}/>
                                </Tooltip>

                            </div>
                        </div>
                    })
                }
            </div>


            <div className={'mt-10'} style={{color: 'var(--color-666666)'}}>
                <span>{t("AdvancedOptionsInSettings")}</span>
                <span className={'cursor-pointer'} style={{textDecoration: 'underline'}} onClick={() => {
                    props.onCallback('showDialogSetting');
                    window.showSettingDialog();
                }}>{t("Settings")}</span>
            </div>

            {
                isShowTips &&
                <div className={'mt-8'} style={{
                    position: 'relative',
                    background: 'var(--file-import-tip-background-color)',
                    padding: '16px',
                    borderRadius: '8px'
                }} onClick={()=>{
                    setIsShowTips(false);
                    localStorage.setItem(EVENT_FILE_MODE_SMALL_TIP_VISIBLE,'false');
                }}>
                    <span style={{color:'#3670F7'}}>{t("LinkModeAccess")}</span>
                    <img className={'img-12 cursor-pointer'} style={{position: 'absolute', top: '12px', right: '12px'}}
                         src={getImagePathWithTheme('file_mode_small_close')}/>
                </div>
            }

        </div>
    )
})

export default FileImportMode;











































